import { render, staticRenderFns } from "./result_choose.vue?vue&type=template&id=70822170&scoped=true&"
import script from "./result_choose.vue?vue&type=script&lang=js&"
export * from "./result_choose.vue?vue&type=script&lang=js&"
import style0 from "./result_choose.vue?vue&type=style&index=0&id=70822170&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70822170",
  null
  
)

export default component.exports